import { Stack } from '@mui/material';

import { Button } from '@/components/form/baseInputs/Button';

import { SmartReviewStepFooterProps } from '../../SmartReviewOnboardingModal.types';
import { useDocumentUploadStepContext } from './context/documentUploadStep.context';
import { usePersistUploadedDocuments } from './hooks/usePersistUploadedDocuments';

/**
 * Footer for the "Documents" step: just Continue. Continue advances immediately
 * and lets the uploaded documents save in the background. Files still uploading
 * when it is pressed are persisted by the background persister once they settle,
 * so the user is never blocked waiting on uploads. There is no Back control
 * because the household already exists. The step tracker can also leave this
 * step, and commits uploads the same way.
 */
export function DocumentUploadFooter({
  onAdvance,
}: SmartReviewStepFooterProps) {
  const { hasBeenClosed, markCommitted } = useDocumentUploadStepContext();
  const { persist } = usePersistUploadedDocuments();

  const handleContinue = () => {
    if (hasBeenClosed()) return;
    // Commit so the background persister saves uploads still in flight, kick off
    // the save of everything already uploaded (fire-and-forget), and advance
    // right away — the save finishes in the background.
    markCommitted();
    void persist();
    onAdvance();
  };

  return (
    <Stack
      direction="row"
      justifyContent="flex-end"
      width="100%"
      position="relative"
    >
      <Button variant="primary" size="sm" onClick={handleContinue}>
        Continue
      </Button>
    </Stack>
  );
}
